// import { useContext } from 'react';
import { useContext } from 'use-context-selector';
import { UIContext } from 'Contexts/UIContext';

export default function useUiState() {
  return useContext(UIContext);
}
